export enum FlexFixtureCategory {
    PREMIUM = 'premium',
    NORMAL = 'normal',
}